import { LegalContentPage } from "@/components/LegalContentPage";

export default function TermosDeUso() {
  return (
    <LegalContentPage
      overline="Legal"
      title="Termos de uso"
      subtitle="Conheça as condições de uso do site da Miríade Turismo."
      seoTitle="Termos de Uso | Miríade Turismo"
      seoDescription="Leia os termos de uso do site da Miríade Turismo e entenda as condições para utilização das nossas páginas e serviços."
      updated="Junho de 2026"
      intro="Ao acessar e utilizar o site da Miríade Turismo, você concorda com os termos descritos abaixo. Recomendamos a leitura atenta deste documento."
      sections={[
        {
          heading: "1. Sobre o site",
          paragraphs: ["Este site tem como finalidade apresentar a Miríade Turismo, facilitar a busca por viagens e oferecer canais de atendimento. As informações têm caráter informativo e podem ser atualizadas a qualquer momento."],
        },
        {
          heading: "2. Uso das informações",
          paragraphs: ["As informações de viagens, destinos e disponibilidade são dinâmicas e podem sofrer alterações. Por isso, devem ser confirmadas com a equipe da Miríade antes de qualquer decisão ou contratação."],
        },
        {
          heading: "3. Responsabilidades do usuário",
          paragraphs: ["Ao utilizar o site, você se compromete a fornecer informações verdadeiras e a utilizar as páginas de forma adequada, respeitando a legislação vigente e os direitos da Miríade Turismo e de terceiros."],
        },
        {
          heading: "4. Propriedade intelectual",
          paragraphs: ["Os conteúdos, marcas, textos e imagens deste site pertencem à Miríade Turismo ou são utilizados mediante autorização. É vedada a reprodução sem autorização prévia."],
        },
        {
          heading: "5. Atendimento e contratações",
          paragraphs: ["As contratações de viagens e serviços ocorrem por meio do atendimento da Miríade e/ou das ferramentas disponibilizadas. Condições específicas de cada serviço serão informadas durante o atendimento."],
        },
        {
          heading: "6. Alterações destes termos",
          paragraphs: ["A Miríade Turismo pode atualizar estes termos periodicamente. A versão vigente estará sempre disponível nesta página."],
        },
        {
          heading: "7. Contato",
          paragraphs: ["Em caso de dúvidas sobre estes termos, fale com a equipe da Miríade Turismo pelos canais oficiais divulgados neste site."],
        },
      ]}
      ctaTitle="Ficou com alguma dúvida?"
      ctaText="Fale com a Miríade e tire suas dúvidas com a nossa equipe."
    />
  );
}
